let { View, Utils } = window.App;

const SELECTOR = '.js-price-grid';

class PriceGrid{
    constructor( el ){
        this.el = el;
        this.$el = $( el );

        this.$inputs = this.$el.find( SELECTOR + "__input" );
        this.$fixed_fees = this.$el.find( SELECTOR + "__fixed-fee" );
        this.$taxes = this.$el.find( SELECTOR + "__tax" );
        this.$subtotal = this.$el.find( SELECTOR + "__subtotal" );
        this.$total = this.$el.find( SELECTOR + "__total" );

        this.$adults = this.$el.find( SELECTOR + "__adult" );
        this.$students = this.$el.find( SELECTOR + "__student" );
        this.$children = this.$el.find( SELECTOR + "__child" );

        this.$inputs.on( 'keyup change', $.proxy( this.calculatePrice, this ) );
        this.$inputs.on( 'change', $.proxy( this.formatInput, this ) );

        this.calculatePrice();
    }

    calculateFees(){
        let fees = 0;
        fees = (parseInt(this.$adults.val()) || 0) * 3 + (parseInt(this.$students.val()) || 0) * 3 + (parseInt(this.$children.val()) || 0) * 3;

        this.$fixed_fees.html( this.priceFormat(fees) );

    }



    calculatePrice(){
        this.calculateFees();
        let subtotal = 0;

        this.$inputs.each( function(){
            let $this = $( this );
            let quantity = parseInt( $this.val(), 10 ) || 0;

            subtotal += quantity * $this.data( 'price' );
        } )

        this.$fixed_fees.each( function(){
            subtotal += parseInt($( this ).html());
        } );

        this.$subtotal.html( this.priceFormat( subtotal ) );

        let total = subtotal;

        this.$taxes.each( ( index, el ) => {
            let $el = $( el );
            let tax = $el.data( 'tax-value' ) * subtotal;

            $el.html( this.priceFormat( tax ) );
            total += tax;
        } );

        this.$total.html( this.priceFormat( total ) );
    }

    formatInput( e ){
        e.currentTarget.value = parseInt( e.currentTarget.value, 10 ) || '';
    }

    priceFormat( amount ){
        return Utils.numberFormat( amount, 2 ) + '$';
    }
}


View.addHook( 'init', v => {
    v.$( SELECTOR ).each( function(){
        new PriceGrid( this );
    } )
} );



// WEBPACK FOOTER //
// ./resources/assets/js/modules/price-grid.js